import {Route, Routes} from 'react-router-dom'
import {Login} from './components/Login'
import {AuthLayout} from './AuthLayout'
import {ForgotPassword} from './components/ForgotPassword'
import {ResetPassword} from './components/ResetPassword'
import {AuthProvider} from './core/AuthProvider'

const AuthPage = () => (
  <AuthProvider>
    <Routes>
      <Route element={<AuthLayout />}>
        <Route path='login' element={<Login />} />
        <Route path='forgot-password' element={<ForgotPassword />} />
        <Route path='reset-password' element={<ResetPassword />} />
        <Route index element={<Login />} />
      </Route>
    </Routes>
  </AuthProvider>
)

export {AuthPage}
